import { render, staticRenderFns } from "./QTHBom.vue?vue&type=template&id=72bf222a"
import script from "./QTHBom.vue?vue&type=script&lang=js"
export * from "./QTHBom.vue?vue&type=script&lang=js"
import style0 from "./QTHBom.vue?vue&type=style&index=0&id=72bf222a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports